import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Button, Form, Space } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import { useTripFiltersStore } from 'shared/stores/use-trip-filters.ts';
import { TripsFiltersDrawer } from './components/trips-filters-drawer';
import { TripsSearch } from './components/trips-search';

export const TripsFilter: React.FC = () => {
  const { filters, search } = useTripFiltersStore();
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  const [form] = Form.useForm();

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <Space size='small'>
        <TripsSearch />
        <Badge dot={!!filters}>
          <Button type='primary' icon={<FilterOutlined />} disabled={!!search} ghost onClick={handleOpen}>
            {t('common:filters')}
          </Button>
        </Badge>
      </Space>
      <TripsFiltersDrawer form={form} isOpen={isOpen} onClose={handleClose} />
    </>
  );
};
